<template>
  <v-container>
    <v-row align="center">
      <v-col cols="12">
        <p>Здесь будет секция с историческими личностями</p>
        <span class="caption">Для корректной работы виджета необходимо добавить связь с историческими личностямя</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'

export default {
  name: 'HistoryFiguresWidget',
  mixins: [dynamicListItemMix]
}
</script>
